import React from "react";
import translate from "../../../i18n/translate";
import "./ProgressPage.scss";
import Accordion from "@material-ui/core/Accordion/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ProgressCard from "./ProgressCard";
import { getRandomNumber } from "../../shared/utils/sharedUtils";

const ProgressAccordion = (props: any) => {
  const { courseModule, sessionModule } = props;
  return (
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={getRandomNumber(courseModule.status).toString()}
          id={getRandomNumber(courseModule.status).toString()}>
          <div className="module-container">
            <div className="module-title">{courseModule.title}</div>
            { courseModule.type && courseModule.type === "digital_test" ?
              <>
                <div className="module-type">Digital test</div>
                <div className="calculation-wrap">{ `${courseModule.perModuleCompletedPercent} ${ courseModule.perModuleExerciseDetail }` }</div>
              </>
            : 
              <>
              { sessionModule ?
                <div className="module-detail-container">
                <div className="prework-wrap">                                                  
                  <div className="module-type">{translate("progress_overall_card_title_prework")}</div>
                  <div className="calculation-wrap">{` ${courseModule.perModuleCompletedPercent} ${ courseModule.perModuleExerciseDetail }`}</div>
                  </div>
                  <div className="session-wrap">
                    <div className="session-details">{translate("progress_overall_card_title_session")}</div>
                    <div className="calculation-wrap">{` ${courseModule.perModuleSessionPercent} ${ courseModule.perModuleSessionDetail }`}</div>
                  </div>
                </div>
              :
                <>
                  <div className="module-type">{translate("progress_activity_tooltip_activitiesCompleted")}</div>
                  <div className="calculation-wrap">{ `${courseModule.perModuleCompletedPercent} ${ courseModule.perModuleExerciseDetail }` }</div>
                </>
              }
              </>
            }
          </div>
        </AccordionSummary>
        <AccordionDetails>
            <div>
            { courseModule && courseModule.units.map((individualUnit: any, index: number) => {
              return (<>
                { sessionModule ?
                  <ProgressCard key={getRandomNumber(index)} sessionCard={ true } courseUnit={individualUnit}></ProgressCard>
                :
                  <ProgressCard key={getRandomNumber(index)} courseUnit={individualUnit}></ProgressCard>
                }
              </>)
              })
            }
            </div>
        </AccordionDetails>
      </Accordion>
  );
};

export default ProgressAccordion;
